/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
const ProductsCounter = () => {
  return (
    <div className="app-card app-card--base  app-card--soft">
      <div className="app-card__container">
        <div className="app-card__info">
          <p>Productos activos</p>
          <p className="text text--md text--strong">0</p>
          <p className="text text--xs secondary-color">Productos en prueba 0</p>
          <p className="text text--xs secondary-color">Productos adquiridos 0</p>
        </div>
      </div>
    </div>
  );
};

export default ProductsCounter;